export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/4bca7c828ddf6f2ef86681e533b2f019.png";